export const normalizeError = (error: unknown): Error => {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === 'string') {
    return new Error(error);
  }

  try {
    return new Error(JSON.stringify(error));
  } catch {
    return new Error(String(error));
  }
};

export const formatRequestDate = (date: Date): string => {
  const offset = date.getTimezoneOffset();
  const shiftedDate = new Date(date.getTime() - offset * 60 * 1000);
  return shiftedDate.toISOString().split('T')[0];
};
